import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { getQueryClient } from '@/providers';
import { persister } from '@/providers/QueryProvider';
import type { TokenDataResponse } from '@/services/token';

export interface AuthStoreProps extends TokenDataResponse {
  login: (payload: TokenDataResponse) => void;
  updateToken: (token: TokenDataResponse) => void;
  logout: () => void;
  isAuthenticated: () => boolean;
}

const initialValues = {
  access_token: '',
  expires_in: 0,
  refresh_token: '',
  token_type: '',
};

export const useAuthStore = create<AuthStoreProps>()(
  devtools(
    persist(
      (set, get) => ({
        ...initialValues,
        isAuthenticated: () => {
          if (!get().expires_in) {
            return false;
          }
          const expires_in = Date.now() + get().expires_in * 1000;
          return expires_in ? Date.now() < expires_in : true;
        },
        login: (payload) => set(payload, false, 'auth/login'),
        logout: async () => {
          set(initialValues, false, 'auth/logout');
          await persister.removeClient();

          getQueryClient().queryClient.removeQueries(); // removes all cached queries
          getQueryClient().queryClient.cancelQueries(); // cancels in-flight queries
        },
        updateToken: (payload) => set(payload, false, 'auth/updateToken'),
      }),
      {
        name: 'auth-storage', // LocalStorage key for persist
      }
    ),
    { name: 'AuthStore' } // DevTools debugging identifier
  )
);
